<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto">
      <div class="grid grid-cols-1 items-center gap-x-5 lg:grid-cols-2">
        <div :class="[imagePosition === 'right' ? 'order-0' : 'order-1']">
          <div v-if="title" class="cta-text-block mb-4" v-html-safe="title"></div>
          <div v-if="subtitle?.html" class="text-lg" v-html-safe="subtitle.html"></div>
          <div v-if="buttons && buttons.length">
            <VcButton
              v-for="(item, index) in buttons"
              :key="index"
              v-bind="getLinkAttr(item.link)"
              size="lg"
              class="my-8 w-fit px-8 md:w-1/2 lg:w-auto"
            >
              {{ item.label }}
            </VcButton>
          </div>
        </div>
        <div class="self-end" :class="[imagePosition === 'right' ? 'order-1' : 'order-0']">
          <img class="rounded-xl" :src="image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";

type ButtonType = {
  label: string;
  link: string;
};

type ContentType = {
  html: string;
  markdown: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  title?: string;
  subtitle?: ContentType;
  image?: string;
  imagePosition?: string;
  imageDescription?: string;
  buttons?: Array<ButtonType>;
  removeWhitespace?: boolean;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
    props.removeWhitespace ? "pb-0 lg:pb-0" : "pb-16 pt-6",
    "mx-auto w-full max-w-screen-xl lg:py-24",
  ];
});
</script>

<style lang="scss">
.cta-text-block {
  @media (min-width: 1024px) {
    h2 {
      font-size: 50px;
      line-height: 60px;
    }
  }
}
</style>
